import React from 'react';

import { SectionBlock } from '../../../blocks/SectionBlock';

export function WelcomeSection(): JSX.Element {
  return (
    <SectionBlock
      skipContentContainer
      title="What can you do with BC experience?"
    >
      <ul className="list-disc pl-5 space-y-2">
        <li>
          <b>Stay in the loop with real-time updates</b> from your teams – just
          click on a team name in the sidebar to instantly view their progress.
        </li>
        <li>
          <b>Spot and resolve critical issues fast</b> – check the “Blockers”
          section below to catch problems before they derail your timeline.
        </li>
      </ul>
    </SectionBlock>
  );
}
